const prefix = 'admin';
export const getProfile = `${prefix}/profile`;

export const updateProfile = `${prefix}/profile`;

export const changePassword = `${prefix}/change-password`;
